import axios from 'axios';
import { cacheAdapterEnhancer, Cache } from 'axios-extensions';
import { getCookie } from '../helpers/csrf';

// Create a cache instance that we can clear programmatically
const cache = new Cache();

const config = {
  baseURL: `${window.envVars.VUE_APP_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { defaultCache: cache }),
  isAxios: true,
};

if (window.envVars.VUE_APP_APP_MODE !== 'development') {
  Object.assign(config.headers, {
    'x-csrf-name': getCookie('csrf-name'),
    'x-csrf-token': getCookie('csrf-token'),
  });
}

/** Creating the instance for axios */
const httpClient = axios.create(config);

// Add Auth0 Access Token to requests if user is authenticated (Vue 3 globalProperties)
import { getInstance } from '@/auth/authWrapper';
httpClient.interceptors.request.use(async config => {
  let authHeader;
  try {
    // Use the global Auth0 instance
    const auth = getInstance();
    if (auth && auth.getTokenSilently) {
      // If migrated to refs, call .value if needed
      const token = await auth.getTokenSilently();
      authHeader = `Bearer ${token}`;
      config.headers.Authorization = authHeader;
    }
  } catch (e) {
    // If not logged in or failed to get token, don't include header
    return config;
  }
  return config;
});

// Export function to clear leads-related cache (list and export endpoints)
export const clearLeadsCache = () => {
  const keysToDelete = [];
  // `cache` is an lru-cache instance (aliased as `Cache` by axios-extensions);
  // it has no public `.store` Map, so iterate/delete via its own API
  cache.forEach((value, key) => {
    // Match both with and without leading slash, and with any query params
    if (key.includes('api/leads/get') || key.includes('api/leads/export')) {
      keysToDelete.push(key);
    }
  });
  keysToDelete.forEach(key => cache.del(key));
};

export default httpClient;
